module.exports = __webpack_public_path__ + "img/ep-monstera.1febf865.jpg";